var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultBrandUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4717,
    cy: 25.7854,
    r: 25,
    fill: "#CDD9E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_6919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8048 13.7854C27.4776 13.7852 28.1256 14.0393 28.6189 14.4967C29.1122 14.9542 29.4144 15.5812 29.4648 16.2521L29.4715 16.4521V35.1187H30.8048V22.4521C30.8048 22.296 30.8595 22.1449 30.9594 22.0251C31.0592 21.9052 31.198 21.8242 31.3515 21.7961L31.4715 21.7854H33.4715C34.1443 21.7852 34.7923 22.0393 35.2856 22.4967C35.7789 22.9542 36.081 23.5812 36.1315 24.2521L36.1382 24.4521V35.1187H37.4715C37.8113 35.1191 38.1382 35.2492 38.3853 35.4825C38.6324 35.7158 38.7812 36.0347 38.8011 36.3739C38.821 36.7132 38.7106 37.0472 38.4925 37.3078C38.2744 37.5684 37.965 37.7359 37.6275 37.7761L37.4715 37.7854H13.4715C13.1317 37.785 12.8048 37.6549 12.5577 37.4216C12.3106 37.1883 12.1619 36.8695 12.1419 36.5302C12.122 36.191 12.2324 35.8569 12.4505 35.5963C12.6686 35.3357 12.978 35.1682 13.3155 35.1281L13.4715 35.1187H14.8048V16.4521C14.8046 15.7793 15.0587 15.1313 15.5162 14.638C15.9736 14.1447 16.6006 13.8425 17.2715 13.7921L17.4715 13.7854H26.8048ZM24.1382 29.7854H20.1382V32.4521H24.1382V29.7854ZM24.1382 24.4521H20.1382V27.1187H24.1382V24.4521ZM24.1382 19.1187H20.1382V21.7854H24.1382V19.1187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_6919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(9.47168 9.7854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBrandUser);
export default __webpack_public_path__ + "static/media/default-brand-user.dca2f809c765f0d1928e5f3d0528c03b.svg";
export { ForwardRef as ReactComponent };